import { Identification } from '@/Domain/Shared'

export class AccountId extends Identification {
  accountId (): string {
    return this.codeId()
  }
}
